import {
  APIListValuesRequest,
  APIListValuesResponse,
  getFetcher,
} from "shared/api/api";
import client from "shared/api/axios";
import { createURL } from "shared/api/utils";

const WORK_ORDERS_BASE_ROUTE = "workOrders";

export const listWorkOrdersValues = (args: APIListValuesRequest) =>
  getFetcher<APIListValuesResponse>(listWorkOrdersValuesRequestURI(args));

const listWorkOrdersValuesRequestURI = ({
  fieldName,
  ...params
}: APIListValuesRequest): string =>
  client.getUri({
    method: "get",
    url: createURL([WORK_ORDERS_BASE_ROUTE, "values", fieldName]),
    params,
  });

const WORK_ORDER_PARTS_BASE_ROUTE = "workOrderParts";

export const listWorkOrderPartsValues = (args: APIListValuesRequest) =>
  getFetcher<APIListValuesResponse>(listWorkOrderPartsValuesRequestURI(args));

const listWorkOrderPartsValuesRequestURI = ({
  fieldName,
  ...params
}: APIListValuesRequest): string =>
  client.getUri({
    method: "get",
    url: createURL([WORK_ORDER_PARTS_BASE_ROUTE, "values", fieldName]),
    params,
  });
